import type { RecallState } from '@disha/contracts';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Per-CLAUDE.md: retrieval-store. Local cache of SM-2-lite RecallState per
 * flashcard artifact, keyed by artifactId.
 *
 * Updates flow via the signals reducer: a `flashcard:grade` event computes
 * the next state via @disha/selection/scheduleRecall, then `upsert()` lands
 * it here. UI surfaces read this store via `useRetrieval` selectors.
 *
 * Server-side canon lives behind RFC-0006 (Student State, mastery facet);
 * sync model lives behind design_stream [explore] Sync.
 */
interface RetrievalState {
  states: Record<string, RecallState>;
  upsert: (state: RecallState) => void;
  reset: () => void;
}

export const useRetrieval = create<RetrievalState>()(
  persist(
    (set) => ({
      states: {},
      upsert: (state) => set((s) => ({ states: { ...s.states, [state.artifactId]: state } })),
      reset: () => set({ states: {} }),
    }),
    { name: 'disha.retrieval' },
  ),
);
